import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

import AlertTooltip from "@/components/alert-tooltip";
import { FormikProps } from 'formik';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface PalletDetailsProps {
  formik: FormikProps<any>;
}

const palletMaterial = [
  'Plastic',
  "Wood"
];
const palletTypes = [
  "36x36x5 plastic",
  "48x40x5 plastic",
  "42x36x5 plastic",
  "48x36x5 plastic",
  "48x40x5.5/5.6 plastic",
  "48x48x5 plastic",
  "48x42x5 plastic",
  "56x48x5 plastic",
  "37x37x5 plastic",
  "43x37x5 plastic",
  "43x36x5 plastic",
  "47x35x5 plastic",
  "47x36x5 plastic",
  "48x37x5 plastic",
  "48x40x5.18 plastic",
  "48x41x5 plastic",
  "48x43x5 plastic",
  "48x44x5 plastic",
  "48x44x6 plastic",

  "36x36x5 wood",
  "48x40x5 wood",
  "42x36x5 wood",
  "48x36x5 wood",
  "48x40x5.5/5.6 wood",
  "48x48x5 wood",
  "48x42x5 wood",
  "56x48x5 wood",
  "37x37x5 wood",
  "43x37x5 wood",
  "43x36x5 wood",
  "47x35x5 wood",
  "47x36x5 wood",
  "48x37x5 wood",
  "48x40x5.18 wood",
  "48x41x5 wood",
  "48x43x5 wood",
  "48x44x5 wood",
  "48x44x6 wood"
]
const PalletDetails: React.FC<PalletDetailsProps> = ({ formik }: { formik: any }) => {
  const renderUnitSelect = (field: string, options: string[]) => (
    <Select
      name={`palletDetails.${field}Unit`}
      defaultValue={options[0]}
      value={formik.values.palletDetails[`${field}Unit`]}
      onValueChange={(value) => formik.setFieldValue(`palletDetails.${field}Unit`, value)}
    >
      <SelectTrigger className="w-[70px] h-6 text-xs bg-unitSelect rounded-[11px] py-3 text-white">
        <SelectValue placeholder="Unit" />
      </SelectTrigger>
      <SelectContent>
        {options.map((option) => (
          <SelectItem key={option} value={option}>{option}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  );

  return (
    <div className="w-full pt-5">
      <div className="flex-center border-border-style-1 border w-full">
        {/* <div className="label-bg flex items-center">
          <Label className="label font-bold flex-grow">Pallet Length*</Label>
          {renderUnitSelect("palletLength", ["inch", "mm"])}
        </div>
        <div className="label-bg flex items-center">
          <Label className="label font-bold flex-grow">Pallet Width*</Label>
          {renderUnitSelect("palletWidth", ["inch", "mm"])}
        </div>
        <div className="label-bg flex items-center">
          <Label className="label font-bold flex-grow">Pallet Depth*</Label>
          {renderUnitSelect("palletDepth", ["inch", "mm"])}
        </div> */}
        <div className="label-bg">
          <Label className="label lg:text-sm text-[9px] font-bold">Pallet Types - size*</Label>
        </div>
      </div>

      <div className="flex-center border-border-style-1 border w-full">
        {/* <div className="relative w-full">
          <input
            name="palletDetails.palletLength"
            placeholder="Enter"
            type="number"
            value={formik.values.palletDetails.palletLength}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className={
              formik.touched.palletDetails?.palletLength &&
                formik.errors.palletDetails?.palletLength
                ? "border-2 border-states-error"
                : ""
            }
          />
          {formik.touched.palletDetails?.palletLength &&
            formik.errors.palletDetails?.palletLength && (
              <AlertTooltip message={formik.errors.palletDetails.palletLength as string} />
            )}
        </div>

        <div className="relative w-full">
          <Input
            name="palletDetails.palletWidth"
            placeholder="Enter"
            type="number"
            value={formik.values.palletDetails.palletWidth}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className={
              formik.touched.palletDetails?.palletWidth &&
                formik.errors.palletDetails?.palletWidth
                ? "border-2 border-states-error"
                : ""
            }
          />
          {formik.touched.palletDetails?.palletWidth &&
            formik.errors.palletDetails?.palletWidth && (
              <AlertTooltip message={formik.errors.palletDetails.palletWidth as string} />
            )}
        </div>

        <div className="relative w-full">
          <Input
            name="palletDetails.palletDepth"
            placeholder="Enter"
            type="number"
            value={formik.values.palletDetails.palletDepth}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className={
              formik.touched.palletDetails?.palletDepth &&
                formik.errors.palletDetails?.palletDepth
                ? "border-2 border-states-error"
                : ""
            }
          />
          {formik.touched.palletDetails?.palletDepth &&
            formik.errors.palletDetails?.palletDepth && (
              <AlertTooltip message={formik.errors.palletDetails.palletDepth as string} />
            )}
        </div> */}

        <div className="relative w-full">
          <Select
            name="palletDetails.palletMaterial"
            value={formik.values.palletDetails.palletTypes}
            onValueChange={(value) => formik.setFieldValue(`palletDetails.palletTypes`, value)}
          >
            <SelectTrigger className="w-full bg-selectBlue border-2 border-required">
              <SelectValue placeholder="Select " />
            </SelectTrigger>
            <SelectContent>
              {palletTypes.map((option) => (
                <SelectItem key={option} value={option}>
                  {option}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          {formik.touched.palletDetails?.palletTypes &&
            formik.errors.palletDetails?.palletTypes && (
              <AlertTooltip message={formik.errors.palletDetails.palletTypes as string} />
            )}
        </div>
      </div>

      <div className="w-full mt-5">
        <div className="label-bg border border-border-style-1">
          <Label className="label mx-auto font-bold text-blue text-center">
            Reference
          </Label>
        </div>
        <div className="w-full h-[400px]">
          <img
            src={"/pallet_details_reference.png"}
            alt="reference"
          />
        </div>
      </div>
    </div>
  );
};

export default PalletDetails;
